import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * Icon for showing a bell.
 * @param {import('@mui/material').SvgIconProps} props - the properties object.
 * @returns {Rect.JSX.Element} - the bell icon.
 */

const IconBellComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

IconBellComponent.displayName = 'IconBell';

const IconBell = memo(IconBellComponent);

export default IconBell;
